export default {
  getCostLine: (state) => state.costLine,
};
